import * as React from "react";
import { AudioEnum } from "../../../../enums";
import { getAudio } from "../../../../utils/AudioUtils";
import AudioPlayerNonInteractiveEffect from "../../AudioPlayer/AudioEffect/AudioPlayerNonInteractiveEffect";

interface Props {
  messageForModal: string;
}

const BetLost: React.FC<Props> = ({ messageForModal }) => (
  <AudioPlayerNonInteractiveEffect
    audioEffectToBePlayed={getAudio(
      messageForModal === "message.betterLuck"
        ? AudioEnum.EFFECT_BET_LOST
        : AudioEnum.EFFECT_MODAL_INFO
    )}
  />
);

export default BetLost;
